import { render, staticRenderFns } from "./164.vue?vue&type=template&id=39f57b21&scoped=true&"
var script = {}
import style0 from "./164.vue?vue&type=style&index=0&id=39f57b21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f57b21",
  null
  
)

export default component.exports